import { Form, FormProps } from 'antd';
import { SelectProps } from 'antd/lib';
import { useMemo } from 'react';
import { useOutletContext } from 'react-router';

import useFormInitialSet from '@/hooks/useFormInitialSet';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';
import { useSelectPropsWithInitial } from '@/hooks/useSelectWithInitialValue';
import { Country } from '@/utils/phoneNumbers';

const useShippingLabelForm = (formProps: FormProps, initialValuesModified, edit?: boolean) => {
  const { form } = formProps;

  // Seteo de valores iniciales y reseteo de campos

  useFormInitialSet(
    form,
    initialValuesModified,
    [
      {
        watchField: 'pais',
        resetFields: ['provincia', 'localidad', 'postal_code'],
      },
      {
        watchField: 'provincia',
        resetFields: ['localidad', 'postal_code'],
      },
      {
        watchField: 'localidad',
        resetFields: ['postal_code'],
      },
    ],
    { withoutInitial: !edit },
  );
  const { paisesSelectProps, companySelectProps } = useOutletContext<{
    paisesSelectProps: SelectProps;
    companySelectProps: SelectProps;
  }>();
  const pais = Form.useWatch('pais', form);
  const provincia = Form.useWatch('provincia', form);
  const countryCode = useMemo(() => Country[pais as keyof typeof Country], [pais]);
  const { selectProps: provinciasSelectProps } = useSelectScrollSearch(
    {
      resource: 'provincias',
      optionLabel: (item: any) => `${item.nombre}`,
      filters: [
        {
          value: pais,
          operator: 'eq' as const,
          field: 'pais',
        },
      ],
    },
    { searchField: 'nombre' },
  );
  const { selectProps: localidadesSelectProps } = useSelectScrollSearch(
    {
      resource: 'localidades',
      optionLabel: (item: any) => `${item.nombre}`,
      filters: [
        {
          value: provincia,
          operator: 'eq' as const,
          field: 'provincia',
        },
      ],
    },
    { searchField: 'nombre' },
  );
  const companySelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: companySelectProps,
    resource: 'empresas',
    initialValue: initialValuesModified?.company,
    labelKey: 'full_name',
    valueKey: 'id',
  });
  const paisesSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: paisesSelectProps,
    resource: 'paises',
    initialValue: initialValuesModified?.pais,
    labelKey: 'nombre',
    valueKey: 'id',
  });
  const provinciasSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: provinciasSelectProps,
    resource: 'provincias',
    initialValue: initialValuesModified?.provincia,
    labelKey: 'nombre',
    valueKey: 'id',
  });
  const localidadesSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: localidadesSelectProps,
    resource: 'localidades',
    initialValue: initialValuesModified?.localidad,
    labelKey: 'nombre',
    valueKey: 'id',
  });

  return {
    companySelectProps: companySelectPropsWithInitials,
    paisesSelectProps: paisesSelectPropsWithInitials,
    provinciasSelectProps: provinciasSelectPropsWithInitials,
    localidadesSelectProps: localidadesSelectPropsWithInitials,
    countryCode,
  };
};

export default useShippingLabelForm;
